import * as React from 'react';
import { SVGProps, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.812 5.218C1.36 10.86-.724 21.166 3.947 29.261a.75.75 0 1 0 1.3-.75C.952 21.07 2.868 11.599 9.716 6.414c6.848-5.185 16.485-4.46 22.481 1.69 5.996 6.15 6.476 15.802 1.118 22.516-5.357 6.714-14.875 8.39-22.203 3.909a.75.75 0 1 0-.782 1.28c7.973 4.875 18.329 3.052 24.158-4.253 5.829-7.305 5.307-17.808-1.217-24.5-6.524-6.691-17.01-7.48-24.46-1.838Z"
      fill="#505460"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.096 35.511a.75.75 0 0 0-.575.892l.637 2.938a.75.75 0 1 0 1.466-.317l-.478-2.206 2.206-.477a.75.75 0 1 0-.318-1.466l-2.938.636Z"
      fill="#505460"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.84 33.817a.75.75 0 0 0-.574.891l.636 2.939a.75.75 0 0 0 1.466-.318l-.477-2.205 2.205-.478a.75.75 0 0 0-.317-1.466l-2.939.637Z"
      fill="#505460"
    />
  </svg>
);

const SpeedButtonIcon = memo(SvgComponent);
export default SpeedButtonIcon;
